import { render, staticRenderFns } from "./Procedure.vue?vue&type=template&id=5f19070d&scoped=true"
import script from "./Procedure.vue?vue&type=script&lang=js"
export * from "./Procedure.vue?vue&type=script&lang=js"
import style0 from "./Procedure.vue?vue&type=style&index=0&id=5f19070d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f19070d",
  null
  
)

export default component.exports